export default __webpack_public_path__ + "static/media/cashflow-home.c78a5e92.png";